<section class="container">
  <div (click)="onClickExit()" class="text-end mt-3"><i role="button" class="bi bi-x-lg"></i></div>
  <div class="text-center row align-items-center height80 ">
    <div class="col">
      <div>
        <h2 class="turquoise30">Bonjour</h2>
        <h2 class="fw-bold turquoise30">{{ fullname }}</h2>
        <h5 class="fw-bold my-3">sur quelle résidence<br> souhaitez-vous travailler aujourd'hui ?</h5>
        @if (residencyList && residencyList.length > 0) {
          <div class="row">
            <div class="col">
              <i class="bi bi-house-door  me-4"></i>
              <mat-form-field>
                <mat-label>Sélectionner une résidence</mat-label>
                <mat-select [(ngModel)]="selectedResidency" (selectionChange)="onChangeResidency()">
                  @for (residency of residencyList;track residency) {
                    <mat-option [value]="residency">{{ residency.nom }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        } @else if (residencyList && residencyList.length === 0) {
          <h6 class="fst-italic">Pas de résidences disponibles</h6>
        } @else {
          <div class="my-3">
            <app-spinner color="#e1b600"></app-spinner>
          </div>
        }

        <button (click)="onClickSyncroniser()" [disabled]="!selectedResidency"
                class="btn fw-bold mt-3 bgturquoise30 px-5"><i class="bi bi-arrow-left-right me-4"></i> SYNCHRONISER
        </button>
      </div>
    </div>
  </div>
</section>
